/**
 * Fixed "+" handling fee currency rules.
 * Global default stays USD (hotel / dynamic orders). Callers that store shekels
 * pass fixedFeeStoredCurrency="ILS" and, for organized tours, persistFixedPlusAsIls.
 */

export function isFixedPlusAmountAuthoritativeIls({
  fixedFeeStoredCurrency = "USD",
  vacationPackageDeal = false,
} = {}) {
  return (
    Boolean(vacationPackageDeal) ||
    String(fixedFeeStoredCurrency || "").toUpperCase() === "ILS"
  );
}

/**
 * Value shown in the amount box from the stored handleFeeData value.
 * "+" in USD storage is converted for display. ILS "+" and any "%" are not.
 */
export function handlingFeeDraftFromStoredValue(
  raw,
  type,
  { authoritativeIls = false, usdToIls } = {}
) {
  if (type === "+" && !authoritativeIls && typeof usdToIls === "function") {
    return usdToIls(raw);
  }
  return raw;
}

/** While «עדכן» is waiting out its delay, do not rewrite the draft the save will read. */
export function shouldDeferHandlingFeeDraftSync(savePending) {
  return Boolean(savePending);
}

/**
 * Amount written to updateOrderFinancials.
 * "%" keeps the existing ILS-absolute → USD conversion.
 * "+" stays in ILS only when the caller opted in (organized tours).
 */
export function resolveOrderFinancialsHandlingFee({
  type,
  absoluteIls,
  persistFixedPlusAsIls = false,
  ilsToUsd,
} = {}) {
  const amount = Number(absoluteIls);
  if (type === "+" && persistFixedPlusAsIls) {
    return amount;
  }
  return typeof ilsToUsd === "function" ? ilsToUsd(amount) : amount;
}
